import { getDashboardStats, getCustomerNotes, getVehicleDetails,getVehicleServiceHistory,getMembers,getCustomers,getVehicles,getCustomerVehicles, getCustomerDetails, getSubscription_plans, getBuddies, getBuddyDetails,getServiceDetails, getCustomerServices, getVehicleNotes, getOrderTicket, getOrderDetails, _getPaymentMethods, getSubscriptionHistory, getAllTickets, getWahuStats } from "./api";


export async function getMembersLoader(){
	return {"members": await getMembers()};
}

export async function wahuLoader(){
	return {data: await getWahuStats()}
}

export async function dashboardLoader(){

	const currentYear = new Date().getFullYear();
	const data =  {
		"members": await getMembers(),
		"stats" : await getDashboardStats(new Date(currentYear, 0, 1),new Date(currentYear, 11, 31))
	};
	// console.log('data',data);
	return data;

}

export async function getTicketInvoiceLoader({params}){
	const ticket = await getServiceDetails(params.service_id);
	const customerDetails = await getCustomerDetails(ticket.details[0].customer_id);
	const data = {
		"service_ticket" : ticket,
		"customer_details" : customerDetails
	}
	return data;
}



export async function getVehiclesLoader(){
	return {vehicles : await getVehicles()}
}

export async function getOrderDetailsLoader({params}){
	return {
		details : await getOrderDetails(params.order_id),
		customer_details: await getCustomerDetails(params.id)
	};
}


export async function getServiceTicketsLoader(){
	return {
		all_tickets : await getAllTickets()
	}
}

export async function getServiceDetailsLoader({params}){
	return {
		vehicle_details: await getVehicleDetails(params.vehicle_id),
		// service_details: []//await getServiceDetails(params.service_id)
		service_details: await getServiceDetails(params.service_id)
	};
}

export async function RoadworthyAndLicensePageLoader(){
	return {data : await getVehicles()};
}

export async function SubscriptionHistoryPageLoader(){
	return {history: await getSubscriptionHistory()};
}

export async function getVehicleDetailsLoader({params}){
	// console.log("paam",params);
	// try {
	const vehicleDetails = await getVehicleDetails(params.id);
	const customerDetails = await getCustomerDetails(vehicleDetails.details.customer_id);
	const vehicleServices = await getVehicleServiceHistory(params.id);
	const vehicleNotes = await getVehicleNotes(params.id);
	return {
		vehicleDetails: vehicleDetails,
		details : customerDetails,
		services: vehicleServices,
		// notes: []
		notes: vehicleNotes
	}
	// } catch (e){
	// 	console.log('went wrong');
	// }
	return {};
}

export async function getBuddiesLoader(){
	return {buddies: await getBuddies()}
}

export async function getBuddyDetailsLoader({params}){
	return {details: await getBuddyDetails(params.id)}
}


export async function getCustomersLoader(){
	return {"customer_list":  await getCustomers()};
}
export async function getCustomerDetailsLoader({ params }) {
	const { id } = params;
	return {
		"details" : await getCustomerDetails(id),
		"services" : await getCustomerServices(id),
		"notes" : await getCustomerNotes(id),
		"plans" : await getSubscription_plans(),
		"payment_methods" : await _getPaymentMethods(),
		"subscription_history" : await getSubscriptionHistory(id)
	};
}

export async function getSubscriptionPlansLoader(){
	return {"plans" : await getSubscription_plans()};
}

export async function AddOrderTicketLoader({params,request}){
	  const url = new URL(request.url);
  const searchParams = url.searchParams;
  const order_id = searchParams.get("order_id");
	return {
		"customer_details" : await getCustomerDetails(params.id),
		"order_ticket" : order_id ? await getOrderTicket(order_id) : null
	};
}



export async function addMemberLoader(){
	return {
		// "utils" : await
	}
}